import { render, staticRenderFns } from "./zTomIndex.vue?vue&type=template&id=5d0daadc&"
import script from "./zTomIndex.vue?vue&type=script&lang=js&"
export * from "./zTomIndex.vue?vue&type=script&lang=js&"
import style0 from "./zTomIndex.vue?vue&type=style&index=0&id=5d0daadc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports